angular.module('clientDashboardApp').directive('contentProvider', ['$log', function ($log) {
    return {
        restrict: 'A',
        scope: {
            provider: '=',
            size: '@'
        },
        replace: true,
        template: '<span><img ng-src="{{providerImageUrl}}" width="{{size}}" height="{{size}}"/></span>',
        link: function (scope, elem, attr) {

            var content = '';

            switch (scope.provider.toUpperCase()) {
                case "GOOGLE":
                    scope.providerImageUrl = '/images/contentproviders/google-square-32.png';
                    break;
                case "YELP":
                    scope.providerImageUrl = '/images/contentproviders/yelp-square-32.png';
                    break;
                case "BING":
                    scope.providerImageUrl = '/images/contentproviders/bing-square-32.png';
                    break;
                case "YELLOWPAGES":
                    scope.providerImageUrl = '/images/contentproviders/yellowpages-square-32.png';
                    break;
                case "YAHOO":
                    scope.providerImageUrl = '/images/contentproviders/yahoo-square-32.png';
                    break;
                default:
                    scope.providerImageUrl = '/images/reviews/' + scope.provider.toLowerCase() + '.png';
                    break;
            }

            elem.append(content);
        }
    }
}]);
